import { useTranslation } from 'react-i18next'
import SAFARI from 'url:./assets/images/anti-human-safari.jpg'
import Donations from './sections/Donations'
import CTAs, { PastFundraisers } from './sections/CTAs'
import Equipment from './sections/Equipment'
import LanguageSelector from './components/LanguageSelector'
import MediaGrid from './components/MediaGrid'
import NotFound from './sections/NotFound'

/** The site is a single page; the .htaccess sends every other path here too */
const HOME_PATHS = ['/', '/index.html']

export default function App() {
  const { t } = useTranslation()

  if (!HOME_PATHS.includes(window.location.pathname)) return <NotFound />

  return (
    <main className='relative min-h-screen w-full bg-zinc-950 text-grey-300 flex flex-col items-center justify-center p-6 text-center gap-8 py-16 md:py-20'>
      <LanguageSelector />
      <h1 className='sr-only'>{t('srTitle')}</h1>
      <img
        src={SAFARI}
        alt={t('logoAlt')}
        className='w-30 h-30 rounded-full object-cover border-2 border-white'
      />

      <p className='text-white opacity-90 mb-2 px-4 text-lg w-full md:max-w-xl'>
        {t('intro')}
        <br />
        <br />
        {t('safari')}
      </p>

      <MediaGrid />

      <CTAs />

      <Equipment />

      <PastFundraisers />
      <a
        href='https://www.ohchr.org/en/press-releases/2025/05/un-commission-concludes-russian-armed-forces-drone-attacks-against-civilians'
        target='_blank'
        rel='noreferrer'
        className='mt-8 text-sm underline opacity-70 text-blue-400'
      >
        {t('unLink')}
      </a>
      <Donations />
    </main>
  )
}
